import * as React from 'react'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

type LoadingSpinnerProps = {
	inline?: boolean
}

// For loading spinners that should be displayed centered in large spaces set inline to false
// For loading spinners that should be displayed inline within text or smaller components, set inline to true

export default function LoadingSpinner({
	inline = false,
}: LoadingSpinnerProps) {
	if (inline) {
		return (
			<CircularProgress
				sx={{
					color: 'primary.dark',
					padding: '1rem',
				}}
			/>
		)
	}
	return (
		<Box
			sx={{
				display: 'flex',
				width: '100%',
				height: `50vh`,
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				padding: '1rem',
			}}
		>
			<CircularProgress
				data-testid={`loading-spinner`}
				sx={{ color: 'primary.dark' }}
			/>
		</Box>
	)
}
